module.exports = __webpack_public_path__ + "img/designer.a636cc0d.jpg";